import * as L from 'leaflet'

interface TileDef extends TitleOptions {
  url: string
}
interface TitleOptions extends L.TileLayerOptions {
  crx: string
}

class TileLayerMulti extends L.TileLayer {
  private _tileDefs: TileDef[] = []
  private _options: TitleOptions | undefined

  constructor(tileDefs: Record<string, TileDef>, options?: TitleOptions) {
    super('', options)
    this._options = options
    this.initialize(tileDefs)
  }

  initialize(tileDefs: Record<string, TileDef>) {
    const defaultUrl =
      tileDefs && Object.keys(tileDefs)[0]
        ? tileDefs[Object.keys(tileDefs)[0]].url
        : ''
    super.setUrl(defaultUrl)

    let zoom = this._options?.minZoom ?? 0
    for (const maxZoomStr in tileDefs) {
      const maxZoom = Number.parseInt(maxZoomStr, 10)
      const tileDef = this._fixTileDef(tileDefs[maxZoomStr])
      for (; zoom <= maxZoom; zoom++) {
        this._tileDefs[zoom] = tileDef
      }
    }
  }

  private _fixTileDef(tileDef: TileDef): TileDef {
    const fixedTileDef = {
      ...L.TileLayer.prototype.options,
      ...tileDef,
    }

    return fixedTileDef
  }
  // 假设 _getSubdomain 是 L.TileLayer 的内部方法，虽然在文档中未明确提及
  private _getSubdomain(tilePoint: L.Point, subdomains: string[]): string {
    // 假设实现类似下面这样，具体实现取决于 L.TileLayer 内部是如何做的
    const index = (tilePoint.x + tilePoint.y) % subdomains.length
    return subdomains[index]
  }
  override getTileUrl(tilePoint: L.Point): string {
    const zoom = this._getZoomForUrl()
    const tileDef = this._tileDefs[zoom]

    return L.Util.template(tileDef.url, {
      s: this._getSubdomain(tilePoint, tileDef.subdomains as string[]),
      z: zoom,
      x: tilePoint.x,
      y: tilePoint.y,
      ...this._options,
    })
  }
}

const tileLayerMulti = (
  defs: Record<string, TileDef>,
  options?: TitleOptions
): TileLayerMulti => {
  return new TileLayerMulti(defs, options)
}

export { TileLayerMulti, tileLayerMulti }
